// Single source of truth for the member-facing main navigation (order, labels,
// testids). Kept icon-free so it is unit-testable without importing the shell
// or lucide. AppShell pairs each item with an icon by testid.
export const MAIN_NAV = [
  { to: "/", label: "Home", end: true, testid: "nav-home" },
  { to: "/games", label: "Games", testid: "nav-games" },
  { to: "/rehearsal", label: "AI Rehearsal", testid: "nav-rehearsal" },
  { to: "/teams", label: "Teams", testid: "nav-teams" },
  { to: "/players", label: "Players", testid: "nav-players" },
  { to: "/standings", label: "Standings", testid: "nav-standings" },
  { to: "/rooms", label: "Rooms", testid: "nav-rooms" },
  { to: "/predict", label: "Predict", testid: "nav-predict" },
  { to: "/leagues", label: "Leagues", testid: "nav-leagues" },
  { to: "/tailgates", label: "Tailgates", testid: "nav-tailgates" },
  { to: "/live", label: "Fan Streams", testid: "nav-live" },
  { to: "/connections", label: "Connections", testid: "nav-connections" },
  { to: "/shop", label: "Shop", testid: "nav-shop" },
  { to: "/profile", label: "Profile", testid: "nav-profile" },
];
